import type { Maybe } from "@entrilia/shared/types";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import type { CalculationType } from "../../../../../../../../../../api/types/fieldConfigurationTypes";
import { calculationTypeCapabilities, getExchangeableCalculationTypes } from "../utilities/calculationTypeCapabilities";

interface Props {
  selectedCalculationType: Maybe<CalculationType>;
  onSelectedCalculationTypeChange: (calculationType: CalculationType) => void;
  readonly: boolean;
}
const TypeOfPredefinedCalculationSelect = ({
  selectedCalculationType,
  onSelectedCalculationTypeChange,
  readonly,
}: Props) => {
  return (
    <FormControl>
      <InputLabel id="calculation-type-label">Type</InputLabel>
      <Select
        labelId="calculation-type-label"
        label="Type"
        value={selectedCalculationType}
        onChange={(evt) => onSelectedCalculationTypeChange(evt.target.value as CalculationType)}
        disabled={readonly}
      >
        {getExchangeableCalculationTypes(selectedCalculationType).map((type) => (
          <MenuItem key={type} value={type}>
            {calculationTypeCapabilities[type].caption}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default TypeOfPredefinedCalculationSelect;
